import { SUBSCRIPTIONS_STORE_NAME, actions } from './store';
import { Dispatch } from '@reduxjs/toolkit';
import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { PricingSubscriptionType } from './constants';
import { createSubscriptionsApi } from './apiFactories/apiFactory';
import { AxiosRequestConfig } from 'axios';
import { ApiRequest } from './models/apiRequestResult';

const SEPARATOR = `__`;
export const subscriptionsApiActionKey = (key: ApiRequest) => `${SUBSCRIPTIONS_STORE_NAME}${SEPARATOR}${key}`;

const getAxiosConfig = (accessToken: string) => {
  const axiosConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axiosConfig;
};

export const fetchPricingSubscription = (accountNumber: string, accessToken: string) => async (dispatch: Dispatch<any>) => {
  const apiKey = subscriptionsApiActionKey(ApiRequest.RetrieveSubscription);
  dispatch(frontendActions.apiRequestSent(apiKey));
  try {
    const subscriptionsApi = createSubscriptionsApi();
    const axiosConfig = getAxiosConfig(accessToken);
    const response = await subscriptionsApi.retrieve({ AccountNumber: accountNumber }, axiosConfig);
    if (!response.data.CurrentPackageName) {
      const getRenewalDate = await subscriptionsApi.getRenewalDate({ AccountNumber: accountNumber }, axiosConfig);
      if (getRenewalDate.status === 200 && getRenewalDate.data && !getRenewalDate.data.error) {
        const { result } = getRenewalDate.data;
        const endDate = new Date(result!);
        response.data.EndDate = endDate.toISOString().split('T')[0];
      }
    }
    dispatch(actions.pricingSubscriptionFetched(response.data));
    dispatch(frontendActions.apiRequestSucceeded(apiKey));
  } catch {
    dispatch(frontendActions.apiRequestFailed({ apiRequest: apiKey }));
  }
};

export const subscribePricingSubscription = (accountNumber: string, accessToken: string, subscribePackage: PricingSubscriptionType) => {
  return async (dispatch: Dispatch<any>) => {
    const apiKey = subscriptionsApiActionKey(ApiRequest.CreateSubscription);
    dispatch(frontendActions.apiRequestSent(apiKey));

    try {
      const subscriptionsApi = createSubscriptionsApi();
      const axiosConfig = getAxiosConfig(accessToken);
      const response = await subscriptionsApi.create({ AccountNumber: accountNumber, PackageName: subscribePackage, BillingCycle: 'Monthly' }, axiosConfig);

      dispatch(actions.pricingSubscriptionSubscribed(response.data));
      dispatch(frontendActions.apiRequestSucceeded(apiKey));
    } catch {
      dispatch(frontendActions.apiRequestFailed({ apiRequest: apiKey }));
    }
  };
};

/* eslint-disable unicorn/consistent-function-scoping */
export const resetPricingSubscribeResult = () => {
  return (dispatch: Dispatch<any>) => dispatch<any>(actions.pricingSubscribeResultReset());
};
/* eslint-enable unicorn/consistent-function-scoping */
